import { inject, Injectable, signal } from '@angular/core';
import { AuthService as AuthServiceApi } from '../../api/auth/auth.service';
import { UserDto } from '../../api/model';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export default class AuthService {
  private readonly authServiceApi = inject(AuthServiceApi);
  private readonly oidcSecurityService = inject(OidcSecurityService);

  currentUser = signal<UserDto | null>(null);

  loadUser(): Observable<UserDto | Pick<UserDto, 'isActive' | 'permissions'>> {
    return this.authServiceApi.getApiAuthMe().pipe(
      map((user) => {
        this.currentUser.set(user);
        return user;
      }),
      catchError(() => {
        const fallback = { isActive: false, permissions: [] };
        this.currentUser.set(fallback);
        return [fallback];
      }),
    );
  }

  hasRole(role: string) {
    return this.currentUser()?.permissions?.includes(role);
  }

  hasAnyRole(roles: string[]) {
    return roles.some((role) => this.hasRole(role));
  }

  isAdmin(): boolean {
    return Boolean(this.currentUser()?.isAdmin);
  }

  logout(): void {
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe();
  }
}
